// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__Ifwze","selected":"tabs_selected__NSAO8"};